import sentry from '../sentry';

export const fetchGroupTags = async (
  authAxios,
  filterEntity = null,
  searchTerm = null
) => {
  try {
    const baseUrl = '/api/v1/';
    const entityPath = filterEntity ? `entities/${filterEntity.uuid}/` : '';
    const endpoint = 'group-tags';
    const queryParam = searchTerm ? `?tag=${searchTerm}` : '';

    const url = `${baseUrl}${entityPath}${endpoint}${queryParam}`;
    const response = await authAxios.get(url);

    const groupTags = response.data.data || [];

    const groupTagsList = groupTags.map((tag) => ({
      label: tag.id,
      value: tag.id,
    }));

    return groupTagsList;
  } catch (error) {
    sentry.sendError(error);
    console.log(error);
    return [];
  }
};
